// extracted by mini-css-extract-plugin
export default {"iconContainer":"SettingsMenu_iconContainer__H8Rll"};